export default "__VITE_ASSET__BG64zwZ0__"